import React from 'react'
import { NumericFormat } from 'react-number-format'

const TableroInforme = ({ resultados, animado, load }) => {

  return (

    <div className={`row ${animado ? 'animated bounce' : null}`}>

      <div className="CajaInforme1">
        {load ? <div className="spinner-border text-success" role="status"><span className="sr-only">Loading...</span></div>
          : <h3><NumericFormat decimalScale={2} value={resultados.ventasTotal + resultados.valorDescPersona} displayType={'text'} thousandSeparator={true} prefix={'$'} /></h3>
        }
        <span>Ventas Brutas</span>
      </div>
      <div className="CajaInforme1">
        {load ? <div className="spinner-border text-success" role="status"><span className="sr-only">Loading...</span></div>
          : <h4>{resultados.pedidosAct + resultados.pedidoCredito}</h4>
        }
        <span>Ventas activas</span>
      </div>
      <div className="CajaInforme1">
        {load ? <div className="spinner-border text-success" role="status"><span className="sr-only">Loading...</span></div>
          : <h4><NumericFormat decimalScale={2} value={resultados.valorPedidosActivos} displayType={'text'} thousandSeparator={true} prefix={'$'} /></h4>
        }
        <span>Total ventas netas</span>
      </div>




      <div className="CajaInforme2">
        {load ? <div className="spinner-border text-warning" role="status"><span className="sr-only">Loading...</span></div>
          : <h4>{resultados.descPersona}</h4>
        }
        <span>Desc personalizados</span>
      </div>
      <div className="CajaInforme">
        {load ? <div className="spinner-border text-danger" role="status"><span className="sr-only">Loading...</span></div>
          : <h4>{resultados.pedidoCredito}</h4>
        }
        <span>Ventas crédito</span>
      </div>
      <div className="CajaInforme3">
        {load ? <div className="spinner-border text-danger" role="status"><span className="sr-only">Loading...</span></div>
          : <h4>{resultados.pedidoCancel}</h4>
        }
        <span>Ventas canceladas</span>
      </div>




      <div className="CajaInforme2">
        {load ? <div className="spinner-border text-warning" role="status"><span className="sr-only">Loading...</span></div>
          : <h4><NumericFormat decimalScale={2} value={resultados.valorDescPersona} displayType={'text'} thousandSeparator={true} prefix={'$'} /></h4>
        }
        <span>Total desc personalizados</span>
      </div>
      <div className="CajaInforme">
        {load ? <div className="spinner-border text-danger" role="status"><span className="sr-only">Loading...</span></div>
          : <h4><NumericFormat decimalScale={2} value={resultados.valorCreditos} displayType={'text'} thousandSeparator={true} prefix={'$'} /></h4>
        }
        <span>Total ventas créditos</span>
      </div>
      <div className="CajaInforme3">
        {load ? <div className="spinner-border text-danger" role="status"><span className="sr-only">Loading...</span></div>
          : <h4><NumericFormat decimalScale={2} value={resultados.valorPedidoCancel} displayType={'text'} thousandSeparator={true} prefix={'$'} /></h4>
        }
        <span>Total ventas canceladas</span>
      </div>


      <div className="CajaInforme2">
        {load ? <div className="spinner-border text-warning" role="status"><span className="sr-only">Loading...</span></div>
          : <h4><NumericFormat decimalScale={2} value={resultados.taxes} displayType={'text'} thousandSeparator={true} prefix={'$'} /></h4>
        }
        <span>Total Taxes</span>
      </div>
      <div className="CajaInforme">
        {load ? <div className="spinner-border text-danger" role="status"><span className="sr-only">Loading...</span></div>
          : <h4><NumericFormat decimalScale={2} value={resultados.totalFee} displayType={'text'} thousandSeparator={true} prefix={'$'} /></h4>
        }
        <span>Total Fee</span>
      </div>


    </div>
  )
}



export default TableroInforme